module.exports = __webpack_public_path__ + "static/media/one-on-one-contributor.e6fe430e.svg";